import { THEME_COLORS } from 'common';

export const palette = {
  common: {
    white: '#FFFFFF',
    black: '#000000',
  },
  primary: {
    main: '#1E88E5',
    light: '#64B5F6',
    dark: '#1976D2',
  },
  custom: {
    darkBrown: '#4C3422',
    mediumBrown: '#8F6645',
    lightBrown: '#B08D73',
    richBrown: '#5C4033',
    beige: '#D4C4BD',
    green: THEME_COLORS.green,
    paleGreen: '#EBF2E7',
    limeGreen: '#B1DB7E',
    grayGreen: '#9AADA0',
    offWhite: '#FCFAF7',
    cream: '#F7F2ED',
    lightGrayBrown: '#E0D8D2',
    anonymous: '#E2E2E2',
    orangeOtcBorder: '#F0A421',
    blueMale: '#A1D3E3',
    pinkFemale: '#EEBED1',
    lightGreenYourCardBorder: '#8BBA53',
    // Gender colors for initials and symbols
    maleInitials: '#2C829F',
    femaleInitials: '#CC3D76',
    // Gender colors for profile image borders
    maleProfileBorder: '#a1d3e3',
    femaleProfileBorder: '#f1d4df',
    // Text colors for person cards
    textTitle: '#4B3221',
    textMain: THEME_COLORS.textMain,
    textSupporting: '#81624D',
    textDescription: '#8F6645',
    // Gradients
    backgroundGradient: 'linear-gradient(to bottom, #EBF2E7, #FFFFFF)',
    // Sponsor dashboard / cohort search colors
    cohortAlternateRowBorder: '#E8F3E5',
    cohortCardBorder: '#C8DDC1',
    cohortColumnHeader: '#795533',
    cohortTableHeaderBg: '#f1f3f0',
    cohortIconBg: '#E2EEDD',
    cohortMetaText: '#617868',
    insufficientDataIconBg: '#F7EBCF',
    insufficientDataIconColor: '#DA9312',
    sponsorPageBackground: '#F2F7F0',
    suppressedText: '#AEAEAE',
    filterAccent: '#225131',
    rangePillYellow: '#fffdd3',
    rangePillGreen: '#e6ffdc',
  },
};
